import { isLoggedIn } from 'axios-jwt';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import {
  Button,
  Flex,
  Heading,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text
} from '@ramp/components';
import { AiOutlineWarning } from '@react-icons/all-files/ai/AiOutlineWarning';
import { useLayoutStore } from 'store/layout';

import { themeColor } from '@ramp/theme';
import { isMdmEnrollPath } from 'router/routes';
import { useWindowWidth } from 'utils/hooks/useWindowWidth';

const MobileUnsupportedModal = () => {
  const { t } = useTranslation();
  const initialRef = useRef(null);
  const windowWidth = useWindowWidth();
  const { pathname } = useLocation();
  const confirmedMobileUnsupported = useLayoutStore(store => store.confirmedMobileUnsupported);
  const setConfirmedMobileUnsupported = useLayoutStore(store => store.setConfirmedMobileUnsupported);

  // The Apple MDM enrollment page is a mobile-first flow (opened on an iPhone /
  // iPad, often inside the Settings webview), so the "not optimized for mobile"
  // warning does not apply there. Reactive via useLocation so an in-app
  // navigation onto/off the route re-evaluates.
  if (isMdmEnrollPath(pathname)) return null;

  if (!isLoggedIn()) return null;

  if (windowWidth > 992 || confirmedMobileUnsupported) {
    return null;
  }

  return (
    <Modal
      isOpen={!confirmedMobileUnsupported}
      onClose={() => setConfirmedMobileUnsupported(true)}
      size="full"
      initialFocusRef={initialRef}
      isCentered
    >
      <ModalOverlay />
      <ModalContent bg={themeColor('whiteAlpha.900', 'blackAlpha.800')}>
        <ModalCloseButton />
        <ModalBody>
          <Flex h="90vh" textAlign="center" direction="column" align="center" justify="center">
            <Icon w={32} h={32} as={AiOutlineWarning} mb={6} />
            <Heading size="md" mb={2} textAlign="center">
              {t('components.mobileUnsupportedModal.title')}
            </Heading>
            <Text mb={8}>{t('components.mobileUnsupportedModal.text')}</Text>
            <Button variant="brand" ref={initialRef} onClick={() => setConfirmedMobileUnsupported(true)}>
              {t('components.mobileUnsupportedModal.btn')}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default MobileUnsupportedModal;
